import Aws from 'aws-sdk'
import Uuid from 'uuid/v4'
import _ from 'lodash'
import Moment from 'moment'

function preset() {
  return {
    tasksQueueUrl: 'https://sqs.ap-northeast-1.amazonaws.com/270961102979/lightfile-simulator-tasks',
    simulationsTable: 'Simulations',
    resourceUrlBase: 'https://s3-ap-northeast-1.amazonaws.com/sim.lightfile.net/',
    i18n: {
      simulations: {
        webp: 'WebPに変換',
        orig: 'オリジナル画像データ',
      },
      formats: {
        webp: '新フォーマットWebP',
        jpeg: 'Jpeg',
        jpg: 'Jpeg',
        png: 'PNG',
        gif: 'GIF',
      },
    },
    colors: {
      formats: {
        jpeg: '#56a0e5',
        jpg: '#56a0e5',
        png: '#ed6d85',
        gif: '#f7cf6b',
        webp: '#6cbebf',
      }
    }
  };
}

class App {
  constructor(values={}) {
    Object.assign(this, values);
  }

  awsParams(params) {
    return _.defaults(params, {
      accessKeyId: 'AKIAI4EONNN7LZP2PWWA',
      secretAccessKey: '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',
      region: 'ap-northeast-1',
    });
  }

  documentClient() {
    return new Aws.DynamoDB.DocumentClient(this.awsParams());
  }

  sqs() {
    return new Aws.SQS(this.awsParams());
  }

  async loadReport(id) {
    const docClient = this.documentClient();
    const data = await docClient.get({
      TableName: preset().simulationsTable,
      Key: { id },
    }).promise();
    return data ? data.Item : undefined;
  }

  async getQueuedTasks() {
    const sqs = this.sqs();
    const queue = await sqs.getQueueAttributes({
      QueueUrl: preset().tasksQueueUrl,
      AttributeNames: ['ApproximateNumberOfMessages', 'ApproximateNumberOfMessagesNotVisible'],
    }).promise();

    const waiting = parseInt(queue.Attributes.ApproximateNumberOfMessages || 0),
      processing = parseInt(queue.Attributes.ApproximateNumberOfMessagesNotVisible || 0);

    return { waiting, processing };
  }

  async sendNewSimulationTask(simulation) {
    const task = {
      id: Uuid(),
      device: simulation.device,
      url: simulation.url,
      ip: simulation.ip,
    };

    if (simulation.email) {
      task.email = {
        to: simulation.email,
        subject: 'WebP導入シミュレーション {{label}}',
        text: `ご利用ありがとうございます。
WebP導入シミュレーションが完了しました。

--------------------------------------------------------------
[PR] 退屈な画像軽量化やWebP対応、忙しいあなたの代わりにAIロボにまかせませんか？
🤖LightFileボット
https://www.ideamans.com/lp1/lightfile-bot/
人のようにFTP・SFTPを介してでWebサーバーの画像をすべて自動で軽量化します。
--------------------------------------------------------------

- 対象ページ: {{label}}
- 対象URL: {{url}}
- 導入レポート: https://sim.lightfile.net/webp/reports/${task.id}

またのご利用をお待ちしています。

📊 WebP導入シミュレーター
https://sim.lightfile.net/webp/`,
      };
    }

    if (simulation.label) {
      task.label = simulation.label;
    }

    const sqs = this.sqs();
    await sqs.sendMessage({
      QueueUrl: preset().tasksQueueUrl,
      MessageBody: JSON.stringify(task),
    }).promise();

    return task;
  }


  async sendNewPackTask(order) {
    const task = {
      action: 'pack',
      id: order.id,
      lang: 'ja',
      email: {
        to: order.email,
        subject: 'WebP変換結果のダウンロード {{title}}',
        text: `ご利用ありがとうございます。
WebP画像のダウンロード準備が完了しました。

{{downloadUrl}}

- 対象ページ: {{title}}
- 対象ページのURL: {{url}}
- 変換レポート: https://sim.lightfile.net/webp/reports/${order.id}

# WebP化の方法

元の画像と同じ階層に.webpファイルを出力しています。
Webサーバーにまとめてアップロードし、
htaccess.txt を参考に.htaccessを記述すると
今すぐページのWebP化が可能です。

# 復元の方法

.htaccessを元に戻せば元の状態に復元します。
アップロードした.webpファイルもサーバーから削除ください。

※ 本件についての保証や無償サポートは一切行っておりません。自己責任にてお試しください。
※ 有償でのサポートおよび、作業の代行などを承っております。末尾の問い合わせ窓口よりご連絡ください。

またのご利用をお待ちしています。

WebP導入シミュレーター https://sim.lightfile.net/webp/
WebP導入に関するお問い合せ https://sim.lightfile.net/webp/about/
`,
      },
    }

    const sqs = this.sqs();
    await sqs.sendMessage({
      QueueUrl: preset().tasksQueueUrl,
      MessageBody: JSON.stringify(task),
    }).promise();

    return task;
  }
}

class History {
  constructor(json, opts={}) {
    this.records = []
    try {
      const records = JSON.parse(json) 
      if (_.isArray(records)) this.records = records
    } catch(ex) {
      // do nothing
    }

    this.options = _.defaultsDeep(opts, {
      limit: 100,
      key: 'id',
    })
  }

  add(record) {
    const key = record[this.options.key]
    if (!_.isNil(key)) {
      this.records = this.records.filter(r => r[this.options.key] !== key)
    } 

    record.time = Moment().toISOString()
    this.records.unshift(record)
    if (this.records.length > this.options.limit) {
      this.records.splice(this.options.limit)
    }
  }

  serialize() {
    return JSON.stringify(this.records)
  }
}

export default { App, History, preset }
